import {
  User,
  Settings,
  CreditCard,
  ArrowUpCircle,
  Ticket,
  ShieldCheck,
  FileText,
  RotateCcw,
  Truck,
  Mail
} from 'lucide-react';
import { LEGAL_DOCUMENTS } from '../../../../features/legal';
import './Sidebar.css';

const ICONS = {
  profile: <User size={20} aria-hidden="true" />,
  settings: <Settings size={20} aria-hidden="true" />,
  billing: <CreditCard size={20} aria-hidden="true" />,
  upgrade: <ArrowUpCircle size={20} aria-hidden="true" />,
  membership: <Ticket size={20} aria-hidden="true" />
};

const LEGAL_ICONS = {
  privacy: <ShieldCheck size={20} aria-hidden="true" />,
  terms: <FileText size={20} aria-hidden="true" />,
  refund: <RotateCcw size={20} aria-hidden="true" />,
  shipping: <Truck size={20} aria-hidden="true" />,
  contact: <Mail size={20} aria-hidden="true" />
};

const SECTIONS = [
  {
    title: 'Account',
    items: [
      { label: 'Profile', path: '/store/profile', icon: ICONS.profile },
      { label: 'Settings', path: '/store/settings', icon: ICONS.settings }
    ]
  },
  {
    title: 'Subscription',
    items: [
      { label: 'Plan & Billings', path: '/store/billing', icon: ICONS.billing },
      { label: 'Upgrade Plan', path: '/store/upgrade', icon: ICONS.upgrade }
    ]
  },
  {
    title: 'Legal & Policies',
    items: LEGAL_DOCUMENTS.map((doc) => ({
      label: doc.label,
      path: doc.path,
      icon: LEGAL_ICONS[doc.key]
    }))
  }
];

const Sidebar = ({ currentPath, onNavigate, membershipEnabled = false }) => {
  const sections = SECTIONS.map((section) => ({ ...section, items: [...section.items] }));
  const allItems = sections.flatMap((section) => section.items);

  return (
    <aside className="sidebar" aria-label="Store account navigation">
      <div className="sidebar-desktop">
        {sections.map((section) => (
          <section key={section.title} className="sidebar-section">
            <h3 className="sidebar-title">{section.title}</h3>
            <nav className="sidebar-nav" aria-label={`${section.title} navigation`}>
              {section.items.map((item) => {
                const isActive = currentPath === item.path;
                return (
                  <button
                    key={item.path}
                    className={`sidebar-item${isActive ? ' active' : ''}`}
                    type="button"
                    onClick={() => onNavigate(item.path)}
                    title={item.label}
                  >
                    <span className="sidebar-item-icon">{item.icon}</span>
                    <span className="sidebar-item-label">{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </section>
        ))}
      </div>

      <nav className="sidebar-mobile-tabs" aria-label="Store account quick navigation">
        {allItems.map((item) => {
          const isActive = currentPath === item.path;
          return (
            <button
              key={item.path}
              className={`sidebar-mobile-tab${isActive ? ' active' : ''}`}
              type="button"
              onClick={() => onNavigate(item.path)}
            >
              <span className="sidebar-item-icon">{item.icon}</span>
              <span className="sidebar-mobile-label">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
